/**
 * Site Settings V2 — "Utility & Account" section: asset tag, utility
 * company, and meter/account identifiers. Hidden for separate
 * (white-label) tenants by the caller.
 *
 * Contains:
 * - UtilitySection (default export)
 */

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SettingsFieldRow,
  SettingsSection,
  SettingsSubsection,
  SettingsTextField,
} from '@sophocles/views/settings/components';

export default function UtilitySection() {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-utility"
      icon={<ReceiptLongIcon />}
      title={t('siteSettings.v2.utility', 'Utility & Account')}
      description={t('siteSettings.v2.utilityDescription', 'Tag, utility company, meter and account numbers.')}
    >
      <SettingsSubsection title={t('siteSettings.v2.account', 'Account')} bordered>
        <SettingsFieldRow
          label={t('siteSettings.tagNumber', 'Tag Number')}
          description={t('siteSettings.v2.tagNumberDescription', 'Asset tag identifier for this site.')}
          controlWidth={240}
        >
          <SettingsTextField name="utility.tag_number" hiddenLabel fullWidth />
        </SettingsFieldRow>
        <SettingsFieldRow
          label={t('siteSettings.utilityCompany', 'Utility Company')}
          description={t('siteSettings.v2.utilityCompanyDescription', 'Provider of electrical service.')}
          controlWidth={240}
        >
          <SettingsTextField name="utility.utility_company" hiddenLabel fullWidth />
        </SettingsFieldRow>
        <SettingsFieldRow
          label={t('siteSettings.utilityMeterNumber', 'Utility Meter Number')}
          description={t('siteSettings.v2.meterNumberDescription', 'Identifier on the physical utility meter.')}
          controlWidth={240}
        >
          <SettingsTextField name="utility.utility_meter_number" hiddenLabel fullWidth />
        </SettingsFieldRow>
        <SettingsFieldRow
          label={t('siteSettings.utilityAccountNumber', 'Utility Account Number')}
          description={t('siteSettings.v2.accountNumberDescription', 'Account on file with the utility.')}
          controlWidth={240}
        >
          <SettingsTextField name="utility.utility_account_number" hiddenLabel fullWidth />
        </SettingsFieldRow>
      </SettingsSubsection>
    </SettingsSection>
  );
}
